import jQuery from 'jquery';
import {
    STORAGE_ITEM_NAME,
    UPDATE_TARGETING,
    BETTING_SPECIAL_OFFER_CLASS,
    HIDE_OFFER_CLASS
} from '../config/storage';


/**
 * @ngdoc service
 * @name CommonUtils.userPreference
 * @requires $cookieStore
 *
 * @description
 * Allows saving and retrieving of user preferences during navigating on website
 */

export default function () {
    'ngInject';

    /**
     * Instance of userPreference
     *
     * @type {object}
     * @default
     */
    const instance = {};

        /**
         * Cookie name
         *
         * @constant
         * @type {string}
         * @default
         */

    instance.isLocalStorageAvailable = true;

    /**
     * Type pedigree
     *
     * @constant
     * @type {number}
     * @default
     */
    instance.TYPE_PEDIGREE = 'pedigree';

    /**
     * Type comments
     *
     * @constant
     * @type {number}
     * @default
     */
    instance.TYPE_COMMENTS = 'comments';

    /**
     * Type listSort
     *
     * @constant
     * @type {number}
     * @default
     */
    instance.TYPE_LIST_SORT = 'list_sort';

    /**
     * Type accordion state
     *
     * @constant
     * @type {number}
     * @default
     */
    instance.TYPE_ACCORDION_STATE = 'accordion_state';

    /**
     * Var listSort Course
     *
     * @constant
     * @type {string}
     * @default
     */
    instance.VAR_LIST_SORT_COURSE = 'course';

    /**
     * Var listSort Time
     *
     * @constant
     * @type {string}
     * @default
     */
    instance.VAR_LIST_SORT_TIME = 'time';

    instance.storage = {
        getItem: (key) => {
            if (this.hasOwnProperty(key)) {
                return this[key];
            }

            return null;
        },
        setItem: (key, value) => {
            this[key] = value;
        }
    };

    /**
     * Getter for cookieName
     */
    instance.getStorageItemName = () => STORAGE_ITEM_NAME;

    /**
     * Setter for preferenceList
     *
     * @param {object} preferenceList
     */
    instance.setPreferenceList = (preferenceList) => {
        try {
            localStorage.setItem(instance.getStorageItemName(), JSON.stringify(preferenceList));
        } catch (e) {
            instance.isLocalStorageAvailable = false;
            instance.storage.setItem(instance.getStorageItemName(),
                JSON.stringify(preferenceList));
            console.warn('You are in a private mode, and we couldn\'t save your preference.');
        }
    };

    /**
     * Getter for preferencesList
     */
    instance.getPreferenceList = () => {
        const storage = instance.isLocalStorageAvailable ? localStorage : instance.storage;

        return JSON.parse(storage.getItem(instance.getStorageItemName())) || {};
    };

    /**
     * Getter for preferencesList
     *
     * @param {number} key
     */
    instance.get = (key) => {
        const preferencesList = instance.getPreferenceList();

        if (!preferencesList.hasOwnProperty(key)) {
            return false;
        }

        return preferencesList[key];
    };

    /**
     * Setter for preferencesList
     *
     * @param {number} key
     * @param {number|bool} value
     */
    instance.set = (key, value) => {
        const preferencesList = instance.getPreferenceList();

        preferencesList[key] = value;
        instance.setPreferenceList(preferencesList);
    };

    /**
     * Toggles user preference
     *
     * @param {number} key
     */
    instance.toggle = (key) => {
        const preferencesList = instance.getPreferenceList();

        preferencesList[key] = !preferencesList[key];
        instance.setPreferenceList(preferencesList);
        jQuery(window).trigger(UPDATE_TARGETING);
    };

    /**
     * Toggle today's offers panel hide class
     */
    instance.initHideTodaysOffersPanel = () => {
        jQuery(BETTING_SPECIAL_OFFER_CLASS).toggleClass(HIDE_OFFER_CLASS);
    };

    /**
     * Indicates whether user has set specific preference
     *
     * @param {number} key
     * */
    instance.isPreferenceSet = (key) => {
        const preferencesList = instance.getPreferenceList();

        return preferencesList.hasOwnProperty(key);
    };

    return instance;
}



// WEBPACK FOOTER //
// ./src/js/services/userPreference.js